import React from "react";
import moment from "moment";
import { isMobile } from "react-device-detect";
export default class Calendar extends React.Component {
  weekdayshort = moment.weekdaysShort();

  state = {
    showCalendarTable: true,
    dateObject: moment(this.props.selectedDate),
    allmonths: moment.months(),
    showSymptoms: false,
    selectedMonth: this.props.currentMonth,
    selectedYear: this.props.currentYear,
    selectedDate: null,
  };

  componentDidUpdate(nextProps) {
    if (
      this.props.selectedDate !== nextProps.selectedDate ||
      this.props.currentMonth !== nextProps.currentMonth ||
      this.props.currentYear !== nextProps.currentYear
    ) {
      this.setState({
        dateObject: moment(this.props.selectedDate),
        selectedMonth: this.props.currentMonth,
        selectedYear: this.props.currentYear,
      });
    }
  }

  daysInMonth = () => {
    return this.state.dateObject.daysInMonth();
  };
  year = () => {
    return this.state.dateObject.format("Y");
  };
  currentDay = () => {
    return this.state.dateObject.format("D");
  };
  firstDayOfMonth = () => {
    let dateObject = this.state.dateObject;
    let firstDay = moment(dateObject).startOf("month").format("d"); // Day of week 0...1..5...6
    return firstDay;
  };
  month = () => {
    return this.state.dateObject.format("MMMM");
  };

  getDates(startDate, stopDate) {
    var dateArray = [];
    var currentDate = moment(startDate);
    var stopDate = moment(stopDate);
    while (currentDate <= stopDate) {
      dateArray.push(moment(currentDate).format("YYYY"));
      currentDate = moment(currentDate).add(1, "year");
    }
    return dateArray;
  }

  toggleIsShown = (e, date, month, showSymptoms) => {
    this.setState({
      selectedDate: date,
      selectedMonth: month,
      showSymptoms: showSymptoms,
    });
  };

  render() {
    let weekdayshortname = this.weekdayshort.map((day) => {
      return <th key={day}>{day.slice(0, 1).toUpperCase()}</th>;
    });
    let blanks = [];
    for (let i = 0; i < this.firstDayOfMonth(); i++) {
      blanks.push(
        <td className="calendar-day empty" key={`id-${i}`}>
          {""}
        </td>
      );
    }
    let daysInMonth = [];
    let currentDayClass = {};
    let currentDate = new Date();
    for (let d = 1; d <= this.daysInMonth(); d++) {
      let appliedclass = {
        backgroundColor: "",
        fontFamily: "",
      };

      let predictPhaseNormalDay = "";
      let predictPhasePeriodDay = "";

      let symptoms = [];

      if (!this.props.isDefault) {
        let OvulationItem = this.props.dateModel.filter((item) => {
          if (item.dayDescription === "Ovulation Day" && item.day == d) {
            return item;
          }
        });
        const result = this.props.dateModel.filter((item) => {
          if (item.day == d) {
            return item;
          }
        });
        if (result.length > 0) {
          if (result[0].predictPhaseNormalDay) {
            predictPhaseNormalDay = result[0].predictPhaseNormalDay;
          }
          if (result[0].predictPhasePeriodDay) {
            predictPhasePeriodDay = result[0].predictPhasePeriodDay;
          }
          if (
            OvulationItem.length > 0 &&
            result[0].day == OvulationItem[0].day
          ) {
            appliedclass = {
              backgroundColor: OvulationItem[0].colorCode,
              fontFamily: OvulationItem[0].fontFamily,
              cursor: "pointer",
            };
            OvulationItem[0].moods.map((mood) => {
              symptoms.push(mood);
            });
            OvulationItem[0].symptoms.map((symptom) => {
              symptoms.push(symptom);
            });
          } else {
            appliedclass = {
              backgroundColor: result[0].colorCode,
              fontFamily: result[0].fontFamily,
              cursor: "pointer",
            };
            if (result[0].moods != null) {
              result[0].moods.map((mood) => {
                symptoms.push(mood);
              });
            }
            if (result[0].symptoms != null) {
              result[0].symptoms.map((symptom) => {
                symptoms.push(symptom);
              });
            }
          }
        }
        if (
          currentDate.getFullYear() === this.props.currentYear &&
          currentDate.getMonth() === this.props.currentMonth &&
          d === currentDate.getDate()
        ) {
          // console.log(d)
          currentDayClass = {
            color: "#DA291C !important",
          };
        } else {
          currentDayClass = {};
        }
      }
      daysInMonth.push(
        <td
          key={d}
          className={
            currentDayClass.color
              ? predictPhasePeriodDay
                ? "calendar-day current-pc-day-class predict-phase-period-day"
                : predictPhaseNormalDay
                ? "calendar-day current-pc-day-class predict-phase-normal-day"
                : "calendar-day current-pc-day-class"
              : predictPhasePeriodDay
              ? `calendar-day predict-phase-period-day`
              : predictPhaseNormalDay
              ? `calendar-day predict-phase-normal-day`
              : `calendar-day`
          }
          style={appliedclass}
          onMouseEnter={(e) => {
            this.toggleIsShown(e, d, this.state.selectedMonth, true);
          }}
          onMouseLeave={(e) => {
            this.toggleIsShown(e, d, this.state.selectedMonth, false);
          }}
        >
          {symptoms.length > 0 &&
            this.state.selectedDate != null &&
            this.state.selectedDate === d &&
            this.state.selectedMonth === this.props.currentMonth &&
            this.state.showSymptoms && (
              <>
                <div className="symptoms-popup">
                  <p className="symptoms-heading">
                    {this.props.dictionary("PeriodCalculator_YouMayExperience")}
                  </p>
                  <div className="symptoms-group">
                    {symptoms.map((symptom) => (
                      <p>{symptom.name}</p>
                    ))}
                  </div>
                </div>
                <span className="symptoms-down-arrow"></span>
              </>
            )}
          <span>{this.props.isDefault ? "" : d}</span>
        </td>
      );
    }
    var totalSlots = [...blanks, ...daysInMonth];
    let rows = [];
    let cells = [];

    totalSlots.forEach((row, i) => {
      if (i % 7 !== 0) {
        cells.push(row);
      } else {
        rows.push(cells);
        cells = [];
        cells.push(row);
      }
      if (i === totalSlots.length - 1) {
        rows.push(cells);
      }
    });

    let daysinmonth = rows.map((d, i) => {
      return <tr key={`id-${i}`}>{d}</tr>;
    });

    return (
      <>
        {!isMobile && (
          <div
            className="tail-datetime-period-calendar col-sm-4"
            style={{ position: "relative" }}
          >
            <div className="calendar-navi">
              {!this.state.showMonthTable && !this.state.showYearEditor && (
                <span className="calendar-label">
                  {this.month()} {this.year()}
                </span>
              )}
            </div>
            {this.state.showCalendarTable && (
              <div className="calendar-date">
                <table className="calendar-day">
                  <thead>
                    <tr>{weekdayshortname}</tr>
                  </thead>
                  <tbody>{daysinmonth}</tbody>
                </table>
              </div>
            )}
          </div>
        )}
        {isMobile && (
          <div
            className="tail-datetime-period-calendar"
            style={{ position: "relative" }}
          >
            <div className="calendar-navi">
              {!this.state.showMonthTable && !this.state.showYearEditor && (
                <span className="calendar-label">
                  {this.month()} {this.year()}
                </span>
              )}
            </div>
            {this.state.showCalendarTable && (
              <div className="calendar-date">
                <table className="calendar-day">
                  <thead>
                    <tr>{weekdayshortname}</tr>
                  </thead>
                  <tbody>{daysinmonth}</tbody>
                </table>
              </div>
            )}
          </div>
        )}
      </>
    );
  }
}
